const basePath = '/admin/website';
const layoutMeta = {
  layout: 'admin',
};

export default [
  {
    path: `${basePath}/article/index`,
    name: `M020040`,
    component: () => import('@/views/admin/website/article/ArticleIndex.vue'),
    meta: {
      ...layoutMeta,
    },
  },
  {
    path: `${basePath}/article/template`,
    name: `M020032`,
    component: () => import('@/views/admin/website/article/Template.vue'),
    meta: { ...layoutMeta },
  },

  {
    path: `${basePath}/picture/index`,
    name: `M020041`,
    component: () => import('@/views/admin/website/picture/Index.vue'),
    meta: { ...layoutMeta },
  },
  {
    path: `${basePath}/picture/template`,
    name: `M020033`,
    component: () => import('@/views/admin/website/picture/Template.vue'),
    meta: { ...layoutMeta },
  },

  {
    path: `${basePath}/video/index`,
    name: `M020042`,
    component: () => import('@/views/admin/website/video/Index.vue'),
    meta: { ...layoutMeta },
  },
  {
    path: `${basePath}/video/template`,
    name: `M020034`,
    component: () => import('@/views/admin/website/video/Template.vue'),
    meta: { ...layoutMeta },
  },

  {
    path: `${basePath}/attachment/index`,
    name: `M020043`,
    component: () => import('@/views/admin/website/attachment/Index.vue'),
    meta: { ...layoutMeta },
  },
  {
    path: `${basePath}/attachment/template`,
    name: `M020035`,
    component: () => import('@/views/admin/website/attachment/Template.vue'),
    meta: { ...layoutMeta },
  },

  {
    path: `${basePath}/column/index`,
    name: `M020039`,
    component: () => import('@/views/admin/website/column/Index.vue'),
    meta: {
      ...layoutMeta,
      dataAuth: {
        bizCode: 'ow',
        operationCode: 'query',
      },
      targetName: '栏目管理',
    },
  },
  {
    path: `${basePath}/column/template`,
    name: `M020031`,
    component: () => import('@/views/admin/website/column/Template.vue'),
    meta: { ...layoutMeta },
  },
];
